const calpak = window.calpak
var cartShippingGift = document.querySelector('.cart__gamification-gifts');

async function trackAddToCart(response) {
    if (response && response.items?.length > 0) {
        const data = response.items[0]
        window._learnq = window._learnq || [];
        window.liQ = window.liQ || [];

        const url = 'https://www.calpaktravel.com/products/' +
            data.handle + '/' +
            calpak.handleize(data.variant_options[0]) +
            (data.variant_options[1] && data.variant_options[1] != 'false' ? `,${calpak.handleize(data.variant_options[1])}`: '');

        // Klaviyo
        const item = {
            Name: data.title,
            ProductID: data.variant_id.toString(),
            Categories: window.item.Categories || [],
            ImageURL: data.image,
            URL: url,
            Price: data.price / 100,
            $value: data.final_line_price / 100,
            total_price: data.final_line_price / 100,
            total_discount: data.total_discount,
            original_total_price: data.original_line_price / 100,
            items: [data],
        }
        _learnq.push(['track', 'Added to Cart', item]);

        // LiveConnect
        const lcItem = {
            "id": data.variant_id.toString(),
            "price": data.price / 100,
            "quantity": 1,
            "currency": "USD"
        }
        window.liQ.push({
            "event": "addToCart",
            "items": [lcItem]
        });
    }
}

const addToCart = function(variant_id, quantity, callback, always, final_sale = false, true_final_sale = false, preorder = false, email = false, message = false, sendOn = false, firstName = false, lastName = false, productForm, properties = {}) {
    if (typeof final_sale == 'undefined') final_sale = false;
    if (typeof true_final_sale == 'undefined') true_final_sale = false;
    if (typeof preorder == 'undefined') preorder = false;

    let items = typeof variant_id == 'object' ? variant_id : [{
        id: variant_id,
        quantity: quantity,
        properties
    }];

    if (final_sale){
        items[0].properties['_final-sale'] = true;
        items[0].properties['_LPROP'] = "Final Sale";
    }
    if (true_final_sale) {
        items[0].properties['_true-final-sale'] = true;
        items[0].properties['_LPROP'] = "Final Sale";
    }
    if (preorder) items[0].properties['_preorder'] = preorder;

    const recipientCheckbox = document.getElementById('recipient-checkbox');
    
    if (recipientCheckbox && recipientCheckbox.checked && productForm.querySelector('input[name="recipient-email"]')){                        
        if (firstName && lastName) items[0].properties['Recipient name'] = `${firstName} ${lastName}`;
        if (firstName && !lastName) items[0].properties['Recipient name'] = firstName;
        if (email) items[0].properties['Recipient email'] = email;
        if (message) items[0].properties['Message'] = message;
        if (sendOn) items[0].properties['Send on'] = sendOn;
        items[0].properties['__shopify_send_gift_card_to_recipient'] = true;
    }

    let formData = {
        cb: Date.now(),
        items: items,
        sections: 'cart-items,cart-json,cart-pair-upsell,cart'
    };

    if (typeof always != 'function') always = () => {};

    fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if (!response.ok) {
            if (response.status == 422) {
                alert("Product not available!");
            } else {
                alert("Error adding product!");
            }

            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
    })
    .then(async response => {
        trackAddToCart(response);
        document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart: response } }));
        if (typeof callback == 'function') callback(response);
    })
    .catch((error) => {
        console.error('Error:', error);
    })
    .then(always, always);
}
calpak.addToCart = addToCart

function changeCartItem(key, qty) {
    return fetch(`${routes.cart_change_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            cb: Date.now(),
            id: key,
            quantity: qty,
            sections: 'cart-items,cart-json,cart-pair-upsell,cart'
        })
    }).then(response => {
        if(!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

        // Extend - Dispatch refreshAjaxSideCart event
        setTimeout(function () {
            window.dispatchEvent(new CustomEvent('refreshAjaxSideCart'));
        }, 500);
        // Extend - End code

        return response.json();
    });
}

const updateCartItems = function(items, callback, always) {
    fetch(`${routes.cart_update_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify({
            updates: items,
            sections: 'cart-items,cart-json,cart-pair-upsell,cart'
        })
    })
    .then(response => {
        if(!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
        return response.json();
    })
    .then(response => {
        if(typeof callback == 'function') callback(response);
    })
    .catch((error) => {
        console.error('Error:', error);
    })
    .then(always, always)
    // Extend - Dispatch event on remove product
    .then(() => {
        window.dispatchEvent(new Event('refreshAjaxCart'))
    });
    // Extend - End code
}
if (cartShippingGift) {
    document.querySelector('.cart__gamification').classList.add('cart__gamification--has-gifts');
}
calpak.updateCartItems = updateCartItems

function gamificationInit() {
    const { subtotal, goals, gifts, wrapper, limit } = settings["cartGamification"];


    document.querySelector(wrapper).innerHTML = '';
    goals.forEach( item => {
        const goalOffset = item.value / limit * 100;
        const goalTemplate = `
            <div class="cart__gamification-goal" style="left: ${goalOffset}%">
                <figure class="cart__gamification-icon ${subtotal >= item.value ? 'cart__gamification-icon--reached' : false}">
                    ${item.icon}
                </figure>
            </div>
        `;
        document.querySelector(wrapper).innerHTML += goalTemplate;
    });





    // gifts.forEach( item => {
    //     const giftTemplate = `
    //         <div class="cart__gamification-goal cart__gamification-goal--gift" style="left: 100%">
    //             <figure class="cart__gamification-icon">
    //                 ${item.icon}
    //             </figure>
    //         </div>
    //     `;
    //     document.querySelector(wrapper).innerHTML += giftTemplate;
    // });

    setGamificationProgress(subtotal * 100);

    document.addEventListener('click', event => {
        if (event.target.matches('.cart__item--gift .color-swatch')) {

            const selectedVariantId = event.target.dataset.firstVariantId;
            const currentVariant = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.dataset.variant;
            const currentId = event.target.parentNode.parentNode.parentNode.parentNode.dataset.id;

            let clean_items = {};
            clean_items[currentVariant] = 0;

            updateCartItems(clean_items, () => {
                //updateCart(data);
                const items = [{
                    id: selectedVariantId,
                    quantity: 1,
                    properties: {
                        '_gift': 'true'
                    }
                }];

                addToCart(items, 1, (data) => {
                    updateCart(data, false, false);
                    activateProductUnit(document.querySelector(".cart__item--gift .product-unit"));
                });
            });

        }
    });
}

function setFreeGiftsByProduct(items) {



    document.querySelectorAll(`.free-gift__selector`).forEach(selector => selector.classList.remove('free-gift__selector--active'));
    document.querySelector('.free-gift__announcement').classList.remove('free-gift__announcement--complete');

    // If any gift disable choose gifts
    const gifts_in_cart = items.filter( item => item.properties?._gift == 'true');
    if(gifts_in_cart.length) {

        document.querySelectorAll(`.free-gift__selector`).forEach(selector => selector.classList.add('free-gift__selector--applied'));
        document.querySelector(`.cart__gamification-gifts`).classList.add('cart__gamification-gifts--reached');
        document.querySelector('.free-gift__announcement').classList.add('free-gift__announcement--complete');

        let current_message = document.querySelector('.cart__gam-verbose').innerHTML;
        if(current_message.slice(-16) == 'and a FREE gift!'){
            if(document.querySelector('.cart__gam-verbose').innerHTML.slice(0,9) == 'Congrats!') {
                current_message = current_message
            } else {
                current_message = `Congrats! ${current_message}`;
            }
        } else {
            current_message = `Congrats! ${current_message.slice(0, -1)} and a FREE gift!`;
        }
        document.querySelector('.cart__gam-verbose').innerHTML = current_message;
        document.querySelector(".cart__gam-verbose--gift").innerHTML = "";
    } else {

        if(settings.cartGamification.gifts.length){
            for(let x in settings.cartGamification.gifts) {
                //const giftKey = items.find(item => item.product_id == settings.cartGamification.gifts[x].key);
                const giftKey = items.find(item => settings.cartGamification.gifts[0].keys.includes(item.product_id));
                if(giftKey){
                    try {
                        document.querySelector(`.free-gift__selector[data-key="${settings.cartGamification.gifts[x].key}"]`).classList.add('free-gift__selector--active');
                        document.querySelector(`.free-gift__selector[data-key="${settings.cartGamification.gifts[x].key}"]`).classList.remove('free-gift__selector--applied');
                        document.querySelector(`.cart__gamification-gifts`).classList.remove('cart__gamification-gifts--reached');
                        document.querySelector('.free-gift__announcement').classList.add('free-gift__announcement--complete');
                        let current_message = document.querySelector('.cart__gam-verbose').innerHTML;
                        if(current_message.slice(-16) == 'and a FREE gift!'){
                            if(document.querySelector('.cart__gam-verbose').innerHTML.slice(0,9) == 'Congrats!') {
                                current_message = `${current_message.slice(0, -1)}`;
                            } else {
                                current_message = `Congrats! ${current_message}`;
                            }
                        } else {
                            current_message = `Congrats! ${current_message.slice(0, -1)} and a FREE gift!`;
                        }
                        document.querySelector('.cart__gam-verbose').innerHTML = current_message;
                        document.querySelector(
                          ".cart__gam-verbose--gift"
                        ).innerHTML = "";
                        setGiftFunctions();
                    } catch {}
                }
            }
        }
    }

    /*
      // Clean gifts from cart if exists
        let clean_items = {};
        const gifts_in_cart = cartItems.filter( item => item.properties?._gift == 'true');

        gifts_in_cart.forEach( gift => {
            clean_items[gift.id] = 0;
        });

        if(Object.keys(clean_items).length) {
            updateCartItems(clean_items, (data) => {
                updateCart(data);
            });
        }
    */

}

function validateGifts () {



    let clean_items = {};
    const gifts_in_cart = cartItems.filter( item => item.properties?._gift == 'true' && item.properties?._related != null);
    if (gifts_in_cart.length) {

        gifts_in_cart.forEach( gift => {
            //const relatedInCart = cartItems.filter( item => item.product_id == gift.properties?._related);
            const relatedInCart = cartItems.filter( item => gift.properties?._related.includes(item.product_id));
            if (!relatedInCart.length) {
                clean_items[gift.id] = 0;
            }
        });
    }

    if(Object.keys(clean_items).length) {
        updateCartItems(clean_items, (data) => {
            document.querySelectorAll(`.free-gift__selector`).forEach(selector => selector.classList.remove('free-gift__selector--applied'));
            document.querySelector(`.cart__gamification-gifts`).classList.remove('cart__gamification-gifts--reached');
            updateCart(data);
        });
    }
}

function setGiftFunctions () {
    // document.querySelectorAll('.free-gift__selector .product-unit').forEach(product => product.classList.add('product-unit--quickadd'));
    // document.querySelectorAll('.free-gift__selector .product-unit__colors').forEach(colors => {
    //     colors.classList.add('product-unit__colors--all', 'slide');
    //     colors.parentNode.parentNode.querySelector('.product-unit__colors--quickadd').append(colors)
    // });
    document.querySelectorAll('.free-gift__selector .product-unit__swatches').forEach(swatches => {
        swatches.classList.add('slider');
        const sliderWrapper = swatches.parentNode;
        sliderWrapper.setAttribute('data-slide', 4);
        sliderWrapper.setAttribute('data-slide-mob', 3);
        sliderWrapper.innerHTML += `<button class="round-icon slider__control slider__control--prev round-icon--prev" title="Previous"></button><button class="round-icon slider__control slider__control--next round-icon--next" title="Next"></button>`;
        sliderWrapper.classList.add('slider__wrapper', 'slider__wrapper--start');
        calpak.checkSlider(sliderWrapper.querySelector('.slider'));
    });


    document.querySelectorAll('.free-gift__selector .product-unit__image.product-link').forEach((link, index) => {
        link.addEventListener('click', function(e) {
            e.preventDefault();
            e.stopPropagation();
            document.querySelectorAll('.free-gift__selector-product').forEach(selector => selector.classList.remove('free-gift__selector-product--active'))
            link.parentNode.parentNode.parentNode.classList.add('free-gift__selector-product--active')
        });
        if (index == 1) {
            document.querySelectorAll('.free-gift__selector-product').forEach(selector => selector.classList.remove('free-gift__selector-product--active'))
            link.parentNode.parentNode.parentNode.classList.add('free-gift__selector-product--active');
        }
    });

    // Select color and add to cart
    document.addEventListener('click', event => {
        if (event.target.matches(".free-gift__selector .color-swatch")) {
            //alert("select the color");

            const giftSelector = event.target.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode.parentNode;
            giftSelector.classList.add('free-gift__selector--applied');
            document.querySelector(`.cart__gamification-gifts`).classList.add('cart__gamification-gifts--reached');

            const gift = event.target.dataset.firstVariantId;
            let items = [{
                id: gift,
                quantity: 1,
                properties: {
                    '_gift': 'true',
                    '_related': giftSelector.dataset.keys
                }
            }];

            if (items.length > 0) {
                addToCart(items, 1, (data) => {
                    updateCart(data);
                });
            }
        }
    });
}

function setGamificationProducts( gifts, goalsVerbose, items_subtotal_price ) {

    const always = () => {};
    let items = [];
    const { goals, limit } = settings["cartGamification"];
    const gamificationIndicator = document.querySelector('.cart__gamification-indicator');

    setTimeout(function(){
        window.fetch(window.Shopify.routes.root + 'cart.js', {
            credentials: 'same-origin',
            method: 'GET',
        })
        .then((response) => response.json())
        .then((cart) => {
            window.cartItems = cart.items;
            if (!cartShippingGift) {
                // Disable gift gamification by cart total
                if(gifts.length == 0) {

                    // Clean gifts from cart if exists
                    let clean_items = {};
                    const gifts_in_cart = cartItems.filter( item => item.properties?._gift == 'true');

                    gifts_in_cart.forEach( gift => {
                        clean_items[gift.id] = 0;
                    });

                    if(Object.keys(clean_items).length) {
                        updateCartItems(clean_items, (data) => {
                            updateCart(data);
                        });
                    }

                } else {

                    gifts.forEach(gift => {
                        if(!cartItems.find(item => item.properties?._gift == 'true')){
                            items.push({
                                id: gift,
                                quantity: 1,
                                properties: {
                                    '_gift': 'true'
                                }
                            });
                        }
                    });

                    if (items.length > 0) {
                        addToCart(items, 1, (data) => {
                            updateCart(data);
                            activateProductUnit(document.querySelector(".cart__item--gift .product-unit"));
                        });
                    }
                }
            } else {
                let verboseTemplate = '';
                let verboseTemplateGift = ''
                if ( goalsVerbose.filter(goal => goal.status == 'complete').length > 0) {
                    for(let x in goalsVerbose) {
                        let prefix = x == 0 ? `You are $${goalsVerbose[x].value} away from` : `Add $${goalsVerbose[x].value} to get`;
                        if (goalsVerbose[x].status == 'complete') {
                            verboseTemplate += `You got ${goalsVerbose[x].goal}! <br>`;
                            verboseTemplateGift += `Add any <a href="/collections/3-piece-luggage-sets">3-piece luggage set</a> to get a <strong>FREE</strong> gift (up to $98 value)!`;
                            document.querySelector('.cart__gam-verbose--gift').innerHTML = verboseTemplateGift;
                            document.querySelector('.free-gift__announcement').classList.add('free-gift__announcement--partial');
                        } else {
                            verboseTemplate += `${prefix} ${goalsVerbose[x].goal}! `;
                            document.querySelector('.free-gift__announcement').classList.remove('free-gift__announcement--partial');
                        }
                    }
                } else {
                    const toFixedPrice = goalsVerbose[0].value;
                    verboseTemplate =
                    `You are $${toFixedPrice.toFixed(2)} away from ${goalsVerbose[0].goal}!`.replace(
                        "FREE",
                        "<b>FREE</b>"
                    );
                    document.querySelector('.free-gift__announcement').classList.remove('free-gift__announcement--partial');
                }

                document.querySelector('.cart__gam-verbose').innerHTML = verboseTemplate;
                document.querySelector('.cart__gam-verbose--gift').innerHTML = verboseTemplateGift;



                let gamificationPercent = (items_subtotal_price * 100) / (limit * 100);
                if(gamificationPercent > 100) gamificationPercent = 100;
                gamificationIndicator.style.setProperty('--gamification-progress', `${gamificationPercent}%`);

                if (gamificationPercent == 100) {
                    const verboseGoals = goals[goals.length - 1].title;
                    document.querySelector(
                    ".cart__gam-verbose"
                    ).innerHTML = `You got ${verboseGoals}!`;

                }

                validateGifts(cartItems);
                // Free gifts
                setFreeGiftsByProduct(cartItems);
            }
        });
    }, 500)
}

function setGamificationProgress(items_subtotal_price, cart = {}) {



    /*
        !!!!!!!!!!!!!!!!!!
        CAUSES AN INFINITE LOOP WHEN GAMIFICATION IS DISABLED IN SETTINGS!!!
        !!!!!!!!!!!!!!!!!!
    */
    // if(document.querySelector('.cart__gamification-goals') != null && document.querySelector('.cart__gamification-goals').innerHTML == '') gamificationInit();

    const { goals, gifts, wrapper, limit } = settings["cartGamification"];
    const cartHeader = document.querySelector('.cart__header');
    const cartGoals = document.querySelector(wrapper);
    const cartGifts = document.querySelector('.cart__gamification-gifts');
    const gamificationIndicator = document.querySelector('.cart__gamification-indicator');
    let freeShippingStarts = -1;
    if(goals.length) freeShippingStarts = goals.find(goal => goal.title == 'FREE shipping').value * 100;


    cartGoals.innerHTML = '';
    let goalsVerbose = [];
    let goalsGifts = [];

    goals.forEach((item, index) => {
        // Set gamification progressbar
        const goalOffset = item.value / limit * 100;
        const goalTemplate = `
            <div class="cart__gamification-goal" style="left: ${goalOffset}%">
                <figure class="cart__gamification-icon ${items_subtotal_price >= (item.value * 100) ? 'cart__gamification-icon--reached' : false}">
                    ${item.icon}
                </figure>
            </div>
        `;
        cartGoals.innerHTML += goalTemplate;

        if (items_subtotal_price < (item.value * 100)) {

            let left_value = item.value - (items_subtotal_price / 100);
            goalsVerbose.push({
                'goal': item.title,
                'status': 'incomplete',
                'value': left_value
            })
        } else {
            goalsVerbose.push({
                'goal': item.title,
                'status': 'complete',
                'value': 0
            });
            if(item.product != '') goalsGifts.push(item.product);
        }
    });

    cartGifts.innerHTML = '';
    gifts.forEach((item, index) => {
        const giftTemplate = `
            <div class="cart__gamification-goal cart__gamification-goal--gift" style="left: 100%">
                <figure class="cart__gamification-icon">
                    ${item.icon}
                </figure>
            </div>
        `;
        cartGifts.innerHTML += giftTemplate;
    });

    setGamificationProducts(goalsGifts, goalsVerbose, items_subtotal_price);

    const verboseMessage = document.querySelector('.cart__gam-verbose').innerHTML;

    if(verboseMessage.indexOf('You got FREE shipping and a FREE gift') === -1) {


    }

    if(freeShippingStarts > -1 && items_subtotal_price >= freeShippingStarts) {
        cartHeader.setAttribute('data-status', 'success');
        return true;
    } else {
        cartHeader.setAttribute('data-status', 'progress');
        return false;
    }
}

// function setGamificationProgress(items_subtotal_price, cart = {}) {

//     if(document.querySelector('.cart__gamification-goals') != null && document.querySelector('.cart__gamification-goals').innerHTML == '') gamificationInit();

//     const { goals, wrapper, limit } = settings["cartGamification"];
//     const cartHeader = document.querySelector('.cart__header');
//     const cartGoals = document.querySelector(wrapper);
//     const gamificationIndicator = document.querySelector('.cart__gamification-indicator');
//     const freeShippingStarts = goals.find(goal => goal.title == 'free standard shipping').value * 100;


//     cartGoals.innerHTML = '';
//     let goalsVerbose = [];
//     let goalsGifts = [];

//     goals.forEach((item, index) => {
//         // Set gamification progressbar
//         const goalOffset = item.value / limit * 100;
//         const goalTemplate = `
//             <div class="cart__gamification-goal" style="left: ${goalOffset}%">
//                 <figure class="cart__gamification-icon ${items_subtotal_price >= (item.value * 100) ? 'cart__gamification-icon--reached' : false}">
//                     ${item.icon}
//                 </figure>
//             </div>
//         `;
//         cartGoals.innerHTML += goalTemplate;

//         if (items_subtotal_price < (item.value * 100)) {

//             let left_value = item.value - (items_subtotal_price / 100);
//             goalsVerbose.push({
//                 'goal': item.title,
//                 'status': 'incomplete',
//                 'value': left_value
//             })
//         } else {
//             goalsVerbose.push({
//                 'goal': item.title,
//                 'status': 'complete',
//                 'value': 0
//             });
//             if(item.product != '') goalsGifts.push(item.product);
//         }
//     });

//     setGamificationProducts(goalsGifts);

//     let verboseTemplate = '';
//     if ( goalsVerbose.filter(goal => goal.status == 'complete').length > 0) {
//         for(let x in goalsVerbose) {
//             let prefix = x == 0 ? `You are $${goalsVerbose[x].value.toFixed(2)} away from` : `Add $${goalsVerbose[x].value.toFixed(2)} to get`;
//             if (goalsVerbose[x].status == 'complete') {
//                 verboseTemplate += `You got ${goalsVerbose[x].goal}! <br>`;

//             } else {
//                 verboseTemplate += `<b>${prefix} ${goalsVerbose[x].goal}!</b> `;
//             }
//         }
//     } else {
//         verboseTemplate = `You are $${goalsVerbose[0].value.toFixed(2)} away from <b>${goalsVerbose[0].goal}</b>!`;
//     }

//     document.querySelector('.cart__gam-verbose').innerHTML = verboseTemplate;

//     let gamificationPercent = (items_subtotal_price * 100) / (limit * 100);
//     if(gamificationPercent > 100) gamificationPercent = 100;
//     gamificationIndicator.style.setProperty('--gamification-progress', `${gamificationPercent}%`);

//     if (gamificationPercent == 100) {

//         const verboseGoals = goals[goals.length - 1].title;
//         document.querySelector('.cart__gam-verbose').innerHTML = `Congrats! <br> <b>You got ${ verboseGoals }!</b>`;

//     }

//     if(items_subtotal_price >= freeShippingStarts) {
//         cartHeader.setAttribute('data-status', 'success');
//         return true;
//     } else {
//         cartHeader.setAttribute('data-status', 'progress');
//         return false;
//     }
// }

function setFreeShippingProgress(cart) {
    const cartContainers = document.querySelectorAll('.cart-page, .cart__body');
    let freeShippingPercent = 0;
    const freeShippingStarts = settings.freeShipping;

    if(cart.requires_shipping) {
        if(cart.item_count > 0) {
            if(isNaN(freeShippingStarts)) return false;

            freeShippingPercent = Math.round((cart.items_subtotal_price * 100) / freeShippingStarts);
            if(freeShippingPercent > 100) freeShippingPercent = 100;
        }
    } else {
        freeShippingPercent = 100;
    }

    const indicator = document.querySelector('.cart__free-shipping-indicator');
    const icon = document.querySelector('.cart__free-shipping-progress__gift-icon');
    cartContainers.forEach(cartContainer => {
        const cartHeader = cartContainer.querySelector('.cart__header');
        if(cartHeader) {
            if(freeShippingPercent == 100) cartHeader.setAttribute('data-status', 'success');
            else cartHeader.setAttribute('data-status', 'progress');
        }

        const freeShippingIndicator = cartContainer.querySelector('.cart__free-shipping-indicator');
        if(!freeShippingIndicator) return false;

        freeShippingIndicator.style.setProperty('--shipping-progress', `${freeShippingPercent}%`);
        freeShippingIndicator.setAttribute('aria-valuenow', `${freeShippingPercent}`);
        icon.setAttribute('aria-valuenow', `${freeShippingPercent}`);
        icon.style.setProperty('--shipping-progress', `${freeShippingPercent}%`);

        if(freeShippingPercent > 0) cartContainer.querySelector('.shipping-value').innerHTML = formatPrice((freeShippingStarts - cart.items_subtotal_price) / 100);
        if(freeShippingPercent == 0) cartContainer.querySelector('.shipping-value').innerHTML = formatPrice(freeShippingStarts / 100);
        //console.log('gwpConfig:', window.gwpConfig);
        if (typeof window.gwpConfig !== 'undefined') {
          gwpConfig.products.forEach(product => {
            const maxValue = parseInt(indicator.getAttribute('aria-valuemax')) * 100;
            const threshold = product.threshold;
            const percentage = (threshold / maxValue) * 100;

            if (freeShippingPercent >= percentage) {
              icon.classList.add('cart__free-shipping-progress__gift-icon--active');
            } else {
              icon.classList.remove('cart__free-shipping-progress__gift-icon--active');
            }
          });
        }
    });


    return freeShippingPercent == 100;
}

function setHeaderItemCounter(cart) {
    let bag = document.querySelector('.header__bag-icon')
    let mobileBag = document.querySelector('.mobile-menu__cart-link .header__bag-icon')
    let mobileBottomBag = document.querySelector('.site-header-bottom .header__bag-icon')
    if(cart.item_count == 0){
        mobileBag?.classList.remove('header__bag-icon--full');
        bag.classList.remove('header__bag-icon--full');
    }
    else {
        bag.classList.add('header__bag-icon--full');
        mobileBag?.classList.add('header__bag-icon--full');
    }
    bag.querySelector('.header__bag-count').innerHTML = cart.item_count;
    if (mobileBag){
        mobileBag.querySelector('.header__bag-count').innerHTML = cart.item_count;
    }
    if (mobileBottomBag){
        mobileBottomBag.querySelector('.header__bag-count').innerHTML = cart.item_count;
    }
}

function updateCartGWPs() {
    const cartGWPItems = document.querySelectorAll('.cart__items-container .cart__item--gwp:not(.cart__item--gwp-loaded)');
    cartGWPItems.forEach(cartGWPItem => {
        if(typeof gwpConfig != 'undefined') {
            for(let i = 0; i < gwpConfig.products.length; i++) {
                const product = gwpConfig.products[i];

                cartGWPItem.querySelector('.cart__item-title').innerHTML = product.title;
                cartGWPItem.querySelector('.cart__item-image .ratio-container').innerHTML = getImage(product.image, '180px', `${product.title} picture`);
                cartGWPItem.querySelector('.cart__item-description').innerHTML = product.text;
            }
            cartGWPItem.classList.add('cart__item--gwp-loaded');
        } else {
            changeCartItem(cartGWPItem.getAttribute('data-key'), 0);
            cartGWPItem.remove();
        }
    });
}

const updateCart = function updateCart(data, jsonIncluded = false) {
    //document.querySelector('.cart__items-container').innerHTML = data.sections['cart-items'];
    document.querySelector('.cart__items-container').innerHTML = data.sections['cart-items'];
    if(document.body.classList.contains('variant')){
        //console.log("🚀 ~ file: cart.js:366 ~ updateCart ~ data.sections['cart-pair-upsell']:", data.sections['cart-pair-upsell'])
        updateUpsell(data.sections['cart-pair-upsell']);
    }

    let cart;
    if(jsonIncluded) cart = data;
    else cart = JSON.parse(calpak.stripHTML(data.sections['cart-json']));

    const cartContainer = document.querySelector('.cart__container, .cart-page');
    let emptyCart = document.querySelector('#CartDrawer .cart__body .cart__empty');

    if (cart.item_count == 0) {
        cartContainer.classList.add('cart__container--empty');
        if(emptyCart) emptyCart.style.display = "flex";
    } else {
        cartContainer.classList.remove('cart__container--empty');
        if(emptyCart) emptyCart.style.display = "none";
    }

    setHeaderItemCounter(cart);
    let freeShipping;
    let checkShipping = document.querySelector('.cart__free-shipping')
    checkShipping ? freeShipping = setFreeShippingProgress(cart) : setGamificationProgress(cart.items_subtotal_price, cart);


    let totalPrice = cart.total_price;
    const isUS = document.body.classList.contains("country--US");
    if(!freeShipping && isUS) totalPrice += 795;

    cartContainer.querySelector('.cart__count').innerHTML = cart.item_count;

    if(cartContainer.querySelector('.cart__count-items')) {cartContainer.querySelector('.cart__count-items').innerHTML = `(${cart.item_count + (cart.item_count > 1 ? " items" : "item")})`;}
    const cartHeader = cartContainer.querySelector('.cart__header');
    if(cartHeader.dataset.status !== 'success'){
        const shippingRate = isUS ? 7.95 : 0;
        if(cartContainer.querySelector('.button--top-checkout')) {cartContainer.querySelector('.button--top-checkout').innerHTML = `<span>Checkout <span class="money--abtest">${formatPrice((cart.total_price / 100) + shippingRate)}</span></span>`;}
    }else{
        if(cartContainer.querySelector('.button--top-checkout')) {cartContainer.querySelector('.button--top-checkout').innerHTML = `<span>Checkout <span class="money--abtest">${formatPrice(cart.total_price / 100)}</span></span>`;}
    }

    cartContainer.querySelector('.cart__total-row--subtotal .cart__total-value').innerHTML = formatPrice(cart.items_subtotal_price / 100);
    cartContainer.querySelector('.cart__payments-amnt').innerHTML = formatPrice(totalPrice / 4 / 100);

    if(totalPrice * 1 <= 5000) cartContainer.querySelector('.cart__4-payments').classList.add('cart__4-payments--limit');
    else cartContainer.querySelector('.cart__4-payments').classList.remove('cart__4-payments--limit');

    cartContainer.querySelector('.cart__total-row--total .cart__total-value').innerHTML = formatPrice(totalPrice / 100);


   if (cartShippingGift) {
     // Reorder cart items

     const cartItems = data.items;
     const reorderedCartItems = [];
     cartItems.filter(function(item){
         if(item.handle.includes('3-piece-luggage-set')){
             document.querySelector(`.cart__gamification-gifts`).classList.add('cart__gamification-gifts--half');
         } else {
             document.querySelector(`.cart__gamification-gifts`).classList.remove('cart__gamification-gifts--half');
         }
     });

     cartItems.forEach(function(item) {

         if (item.properties?._gift == 'true') {
         reorderedCartItems.unshift(item);
         } else {
         reorderedCartItems.push(item);
         }
     });

     data.items = reorderedCartItems;
     document.querySelector('.cart__items-container').innerHTML = data.sections['cart-items'];
   }

  // update dynamic announcment using html from cart section
  const dynamicAnnouncements = document.querySelectorAll('.cart__promo[data-type="dynamic_announcement"]');
  dynamicAnnouncements.forEach(dynamicAnnouncement => {
    if (data.sections.cart) {
      const cartDOM = document.createElement("div");
      cartDOM.innerHTML = data.sections.cart;
      const dynamicAnnouncementDOM = cartDOM.querySelector(".cart__promo[data-type='dynamic_announcement']");
      dynamicAnnouncement.innerHTML = dynamicAnnouncementDOM.innerHTML;
    } else {
      fetch(window.Shopify.routes.root + "?sections=cart")
        .then(res => res.json())
        .then(data => {
          const cartHTML = data.cart;
          const cartDOM = document.createElement("div");
          cartDOM.innerHTML = cartHTML;
          const dynamicAnnouncementDOM = cartDOM.querySelector(".cart__promo[data-type='dynamic_announcement']");
          dynamicAnnouncement.innerHTML = dynamicAnnouncementDOM.innerHTML;
        })
    }
  })

    updateCartGWPs();

    if(window.holidayGamification != undefined){
        const cart_non_eligible_message = window.holidayGamificationData?.cart_non_eligible_message;
        let currentFinalPrice = 0;
        cart.items.forEach((item) => {
            if (item.properties["_holiday_gift"]) {
            currentFinalPrice += item.original_line_price;
            }
        });
        if (currentFinalPrice < window.holidayGamification.lastGoal) {
            const cartItems = cartContainer.querySelectorAll(".cart__item");
            cartItems.forEach(cartItem=>{
                if(cartItem.dataset.holidayGift == "true"){
                    const nonEligibleMessage = document.createElement("div");
                    nonEligibleMessage.className = "non-eligible-message";
                    nonEligibleMessage.innerHTML = cart_non_eligible_message
                    cartItem.querySelector(".cart__item-info").insertBefore(nonEligibleMessage, cartItem.querySelector(".cart__item-info .cart__item-info-buttons"))
                }
            })
        }
    }
}
calpak.updateCart = updateCart

const closeCart = function(triggerElement) {
    const cartContainer = document.querySelector('.cart__container');
    if(!cartContainer) return;
    cartContainer.classList.remove('cart__container--visible');
    document.querySelector('.open-cart-link')?.focus();
    setTimeout(() => {
        cartContainer.classList.remove('cart__container--active');
        document.body.classList.remove('modal-open');
        if(triggerElement){
            triggerElement.focus();
        }
    }, 310);
}
calpak.closeCart = closeCart

function openPopUp(title, color, img) {
    const popupContainer = document.querySelector(".popup-container");
    popupContainer.querySelector(".image").innerHTML = img.outerHTML;
    popupContainer.querySelector(".product-name").innerHTML = title;
    popupContainer.querySelector(".variation").innerHTML = color.charAt(0).toUpperCase() + color.slice(1).toLowerCase();

    popupContainer.classList.remove("visually-hidden");

    setTimeout(() => {
      popupContainer.classList.add("visually-hidden");
    }, "5000");
}

let triggerElement = null;

function trapFocus(modal) {
    function handleTabKey(event) {
        const focusableSelectors = [
            'a[href]',
            'area[href]',
            'input:not([disabled])',
            'select:not([disabled])',
            'textarea:not([disabled])',
            'button:not([disabled])',
            'datalist:not([disabled])',
            'object',
            'embed',
            '[tabindex]:not([tabindex="-1"])',
            '[contenteditable]',
            "iframe"
        ].join(', ');

        const allFocusableElements = modal && modal.querySelectorAll(focusableSelectors);

        const focusableElements = Array.from(allFocusableElements).filter(element => {
            const isHidden = (el) => {
                while (el) {
                    if (window.getComputedStyle(el).display === 'none' || window.getComputedStyle(el).opacity === '0' || el.getAttribute("tabindex") === "-1") {
                        return true;
                    }
                    el = el.parentElement;
                }
                return false;
            };
            return !isHidden(element);
        });

        if (focusableElements.length === 0) return;

        const firstElement = focusableElements[0];

        const lastElement = focusableElements[focusableElements.length - 1];

        if (event.key === 'Tab') {
            if (event.shiftKey) {
                if (document.activeElement === firstElement) {
                    event.preventDefault();
                    lastElement.focus();
                }
            } else {
                if (document.activeElement === lastElement) {
                    event.preventDefault();
                    firstElement.focus();
                }
            }
        }
    }
    
    document.addEventListener('keydown', handleTabKey);
    return () => document.removeEventListener('keydown', handleTabKey);
}

document.addEventListener('keydown', () => {
    const cartContainer = document.querySelector('.cart__container');

    function moveFocusToCloseButton() {
        const closebtn = document.querySelector(".close-button--cart");
        if (closebtn) {
            closebtn.focus();
        }
    }

    function handleFocusChange() {
        const activeElement = document.activeElement;

        if (cartContainer.contains(activeElement)) {
            if (activeElement.tagName === 'IFRAME') {
                const iframeWindow = activeElement.contentWindow || activeElement.contentDocument;
                
                iframeWindow.addEventListener('blur', () => {
                    setTimeout(() => {
                        if (!cartContainer.contains(document.activeElement)) {
                            moveFocusToCloseButton();
                        }
                    }, 0);
                });
            }
        } else if (!cartContainer.contains(activeElement)) {
            moveFocusToCloseButton();
        }
    }

    function setupFocusListeners() {
        document.addEventListener('focusin', handleFocusChange);

        document.addEventListener('keydown', (event) => {
            if (event.key === 'Tab') {
                handleFocusChange();
            }
        });
    }

    function setupObserver() {
        const observer = new MutationObserver(handleFocusChange);

        observer.observe(document.body, {
            childList: true,
            subtree: true
        });

        if (cartContainer && cartContainer.classList.contains('cart__container--active')) {
            observer.observe(cartContainer, {
                childList: true,
                subtree: true
            });
        } else {
            observer.disconnect();
        }
    }

    setupFocusListeners();
    setupObserver();
});

const removeCaliforniaItems = async () => {
    // temp disable cart removal of items
    return;

};
calpak.removeCaliforniaItems = removeCaliforniaItems;
// temp disable califronia checks
// document.addEventListener("calpak:loaded", function () {
//     removeCaliforniaItems();
// });


const openCart = function(e) {
    const cartContainer = document.querySelector('.cart__container');
    if(!cartContainer || cartContainer.classList.contains('cart__container--visible')) return;

    if(settings["cartGamification"] && settings["cartGamification"].gifts.length > 0 && document.querySelector('.cart__gamification-goals') != null && document.querySelector('.cart__gamification-goals').innerHTML == '') gamificationInit();

    cartContainer.classList.add('cart__container--active');
    setTimeout(() => {
        cartContainer.classList.add('cart__container--visible');
    }, 10);
    document.body.classList.add('modal-open');

    updateCartGWPs();
    // removeCaliforniaItems();

    if(calpak.isset(localStorage.getItem('guest_checkout')) && localStorage.getItem('guest_checkout')) {
        document.querySelector('.cart__footer .button--checkout')?.setAttribute('href', '/checkout');
    }

    // Extend - Dispatch refreshAjaxSideCart event
    setTimeout(function() {
        window.dispatchEvent(new CustomEvent('refreshAjaxSideCart'));
    },500);
    // Extend - End code

    // Track payment and checkout buttons within the Cart Drawer
    function trackCartDrawerButtons(screen) {
        const buttons = [
            { selector: "#CartDrawer shop-pay-wallet-button", section: "add_to_cart_cart_shoppay" },
            { selector: "#CartDrawer .cart__footer .button--checkout", section: "add_to_cart_cart_checkout" },
            { selector: "#CartDrawer shopify-paypal-button", section: "add_to_cart_cart_paypal" },
            { selector: "#CartDrawer .cart__body-top .button--checkout", section: "add_to_cart_cart_checkout" },
            { selector: "#CartDrawer shopify-google-pay-button", section: "add_to_cart_cart_googlepay" },
            { selector: "#CartDrawer shopify-apple-pay-button", section: "add_to_cart_cart_applepay" }
        ];

        const addDataLayerEvent = (element, section) => {
            if (element && !element.dataset.eventAttached) {
                element.addEventListener("click", () => {
                    window.dataLayer.push({
                        event: 'ga4-event',
                        "ga4_event_name": `${section}--${screen}`
                    });
                }, { once: true });

                element.dataset.eventAttached = true;
            }
        };

        buttons.forEach(({ selector, section }) => {
            const element = document.querySelector(selector);
            addDataLayerEvent(element, section);
        });
    }

    setTimeout(() => {
        let closeButton = document.querySelector(".close-button.close-button--cart")
        if (closeButton) {
            closeButton.focus();
            closeButton.addEventListener('focus', () => {
                closeButton.style.border = "1px dashed #aeaeae";
            });

            closeButton.addEventListener('blur', () => {
                closeButton.style.border = "none";
            });
        }
        triggerElement = e;
        const form = document.querySelector('.shopify-product-form');
        let cartbtn = form?.querySelector('.button--pdp__submit');
        if(cartbtn){   
            triggerElement = cartbtn;
        }

        trapFocus(cartContainer);

        let currentScreen = window.innerWidth < 900 ? 'mobile' : 'desktop';
        trackCartDrawerButtons(currentScreen);
        calpak.hideProductsForCalifornia();
    }, 500);

    const products = document.querySelectorAll('.cart__upsell-items .product-unit');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.setAttribute('tabindex', '-1');
                entry.target.removeAttribute('aria-hidden');
            } else {
                entry.target.setAttribute('tabindex', '-1');
                entry.target.setAttribute('aria-hidden', 'true');
            }
        });
    }, { threshold: 0.1 });

    products?.forEach((product, index) => {
        observer.observe(product);
    });

    let upsellWrapper = document.querySelector("#cart_upsell .cart__upsell-items");
    function adjustCartUpsellSwatches() {
        products && products.forEach((item, i) => {
            item.setAttribute("aria-label", `slide ${i + 1} of ${products.length}`);
            const swatchesContainer = item?.querySelector('.product-unit__swatches');
            const colorButtons = Array.from(swatchesContainer?.querySelectorAll('.color-swatch'));
            calpak.adaColorSwatches(item, colorButtons, "sidecart");
        });
    }
    const adjustCartUpsellSwatchesDebounced = calpak.debounce(adjustCartUpsellSwatches, 500);
    adjustCartUpsellSwatchesDebounced();
    upsellWrapper.addEventListener('scroll', adjustCartUpsellSwatches);

    let cartHeader = document.querySelector('.cart__header');
    let cartProducts = document.querySelector('.cart__body-top');
    let cartBottom = document.querySelector('.cart__body-bottom');

    function adjustProductPosition() {
        if (cartHeader && cartBottom && cartProducts) {
            const headerHeight = cartHeader.clientHeight - 15;
            const bottomHeight = cartBottom.clientHeight - 15;
            cartProducts.style.top = `${headerHeight}px`;
            cartProducts.style.height = `calc(100vh - ${bottomHeight + headerHeight}px)`;
        }
    }

    adjustProductPosition();

    const resizeObserver = new ResizeObserver(() => {
        adjustProductPosition();
    });

    resizeObserver.observe(cartHeader);

    let listenersAttached = false;
    function moreForYouCartCarousel() {
        const prevButton = document.querySelector('.cart__body-main .cart__upsell .slider__nav--desktop .slider__control--prev');
        const nextButton = document.querySelector('.cart__body-main .cart__upsell .slider__nav--desktop .slider__control--next');
        const sliderContainer = document.querySelector('.cart__upsell-items');
        const allSlides = document.querySelectorAll('.cart__body-main .cart__upsell .cart__upsell-items .product-unit');
        const slides = Array.from(allSlides).filter(slide => getComputedStyle(slide).display !== 'none');

        let isDesktop = window.innerWidth >= 900;

        if (isDesktop) {
            let currentIndex = 0;
            const totalProducts = slides?.length;
            const productSize = slides[0]?.clientHeight || 0;
            const productTop = slides[0]?.getBoundingClientRect().bottom;
            const productBottom = slides[1]?.getBoundingClientRect().top;
            const gap = productBottom - productTop;

            const updateButtonStatus = () => {
                const prevProductsCount = Math.max(currentIndex, 0);

                prevButton.style.display = prevProductsCount <= 0 ? "none" : "block";
                const isAtBottom = (sliderContainer.scrollTop + sliderContainer.clientHeight) === sliderContainer.scrollHeight;
                nextButton.style.display = !isAtBottom ? "block" : "none";
            };

            const updateCarouselPosition = () => {
                const scrollHeight = productSize + gap;
                sliderContainer.scrollTo({
                    top: scrollHeight * currentIndex,
                    behavior: "smooth"
                });

                updateButtonStatus();
            };

            const handleButtonInteraction = (event, isNext = false) => {
                if (event.type === 'click' || event.key === 'Enter' || event.key === ' ') {
                    event.preventDefault();

                    let nextIndex = isNext ? currentIndex + 1 : currentIndex - 1;
                    if (nextIndex < 0 || nextIndex >= totalProducts) return;

                    currentIndex = nextIndex;
                    updateCarouselPosition();
                }
            };

            function addEventListenersIfNotAdded(element, eventType, handler, flagName) {
                if (!element.dataset[flagName]) {
                    element.addEventListener(eventType, handler);
                    element.dataset[flagName] = "true";
                }
            }

            if (!listenersAttached) {
                addEventListenersIfNotAdded(prevButton, 'click', (event) => handleButtonInteraction(event, false), 'clickListenerAdded');
                addEventListenersIfNotAdded(nextButton, 'click', (event) => handleButtonInteraction(event, true), 'clickListenerAdded');
                addEventListenersIfNotAdded(prevButton, 'keydown', (event) => handleButtonInteraction(event, false), 'keydownListenerAdded');
                addEventListenersIfNotAdded(nextButton, 'keydown', (event) => handleButtonInteraction(event, true), 'keydownListenerAdded');

                sliderContainer.addEventListener('scroll', calpak.debounce(() => {
                    const scrollTop = sliderContainer.scrollTop;
                    const totalHeight = productSize + gap;
                    currentIndex = Math.round(scrollTop / totalHeight);
                    currentIndex = Math.min(Math.max(currentIndex, 0), totalProducts - 1);
                    updateButtonStatus();
                }, 100));
                listenersAttached = true;
            }
            updateCarouselPosition();
        }
    }

    window.addEventListener("resize", moreForYouCartCarousel);
    moreForYouCartCarousel();
}
calpak.openCart = openCart

var closeCartLinks = document.querySelectorAll('.close-button--cart, .cart__overlay, .cart__empty-continue-button');
closeCartLinks.forEach(closeCartLink => {
    closeCartLink.addEventListener('click', (e) => {
        e.preventDefault();
        closeCart(triggerElement);
    });
    closeCartLink.addEventListener('keydown', (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            closeCart(triggerElement);
        }
    });
});

window.addEventListener("click", async (e) => {
    if(e.target.classList.contains('cart__item-remove')) {
        e.preventDefault();

        const cartItem = e.target.closest('.cart__item');
        if(!cartItem) return;

        cartItem.classList.add('cart__item--removing');

        let data = await changeCartItem(cartItem.getAttribute('data-key'), 0);
        document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart: data } }));
    } else if (e.target.classList.contains('qty-button')) {
        e.preventDefault();

        const container = e.target.closest('.qty-selector');
        if(!container) return;

        const cartItem = container.closest('.cart__item');

        const valueInput = container.querySelector('input[name="qty"]');
        let qty = Number(valueInput.value);
        if(isNaN(qty)) return;

        if(e.target.classList.contains('qty-button--less')) {
            if(qty > 1) qty--;
            else {
                qty = 0;
                cartItem.classList.add('cart__item--removing');
            }
        } else qty++;

        valueInput.value = qty;

        let data = await changeCartItem(cartItem.getAttribute('data-key'), qty);
        if(typeof gwpConfig != 'undefined') {
            if (typeof getGWP == 'undefined') await calpak.loadScript(scripts.gwp);
          data = await checkGWP(data);
        }
        document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart: data } }));
    } else if (e.target.classList.contains('remove-bundle')) {
      e.preventDefault();

      const bundleKey = e.target.dataset.bundleKey;
      if (!bundleKey) return;

      e.target.closest(".cart-item--bundle-header").classList.add('cart__item--removing');

      e.target.closest(".cart__items").querySelectorAll(".cart__item[data-bundle-key='" + bundleKey + "']").forEach(item => item.classList.add('cart__item--removing'));

      const cart = await calpak.cart.getState();

      let updates = {};

      cart.items.forEach((item) => {
        if (item.properties && item.properties._bundle_product_key === bundleKey) {
          updates[item.key] = 0;
        }
      });

      calpak.updateCartItems(updates, (c) => {
        calpak.updateCart(c)
        window.dispatchEvent(new CustomEvent('refreshAjaxSideCart'));
      })
    }
});

function trappingCartFocus(){
    const firstFocusableElement = document.querySelector('.cart__container .close-button--cart');
    const lastFocusableElement = document.querySelector('.cart__container .button--checkout');
    const qvBody = document.querySelector('.cart__container .cart__body');
    const qvOverlay = document.querySelector('.cart__container .cart__overlay');
    qvBody?.addEventListener('keydown', function(e) {
        if(e.target === firstFocusableElement && e.key === 'Tab' && e.shiftKey) {
            e.preventDefault();
            lastFocusableElement.focus();
        } else if(e.target === lastFocusableElement && e.key === 'Tab' && !e.shiftKey) {
            e.preventDefault();
            firstFocusableElement.focus();
        }
    });

    firstFocusableElement?.addEventListener('click', function(e) {
        calpak.previousElement?.focus();
        calpak.previousElement = null;
        });
    qvOverlay?.addEventListener('click', function(e) {
        calpak.previousElement?.focus();
        calpak.previousElement = null;
        });
}
setTimeout(() => {
    trappingCartFocus();
}, 10);

/* eslint-disable no-undef */
function support() {
	if (!window.DOMParser) return false;

	const parser = new DOMParser();

  try {
		parser.parseFromString('x', 'text/html');
	} catch (err) {
		return false;
	}

	return true;
};

/**
 * Convert a template string into HTML DOM nodes
 * @param  {String} str The template string
 * @return {Node}       The template HTML
 */
function stringToHTML(str) {
	// If DOMParser is supported, use it
	if (support()) {
		const parser = new DOMParser();
		const doc = parser.parseFromString(str, 'text/html');
		return doc.body;
	}

	// Otherwise, fallback to old-school method
	const dom = document.createElement('div');
	dom.innerHTML = str;
	return dom;
}

function updateUpsell(str){
    const upsellContainer = document.querySelector('.cart__upsell-items--ab-test-variant');
    upsellContainer.innerHTML = stringToHTML(str).innerHTML;
    const products = upsellContainer.querySelectorAll(".product-unit")
    products.forEach(product => {
        activateProductUnit(product);
    })

    let visibleUpsells = [];
    document.querySelectorAll('.cart__items .cart__item').forEach(item => visibleUpsells.push(item.dataset.id));
    document.querySelectorAll('.cart__upsell-items--ab-test-variant .product-unit').forEach(item => {
        visibleUpsells.includes(item.dataset.id) ? item.style.display = 'none' : '';
        visibleUpsells.push(item.dataset.id);
    });

}

document.addEventListener('theme:cart:updated', async (e) => {
  let data = e.detail?.cart || {};

  if(typeof gwpConfig != 'undefined') {
      if (typeof getGWP == 'undefined') await calpak.loadScript(scripts.gwp);
    data = await checkGWP(data);
    updateCart(data);
  } else {
    updateCart(data, true);
  }
})

async function renderCartOnLoad() {
  if(typeof gwpConfig != 'undefined') {
    if(typeof getGWP == 'undefined') await calpak.loadScript(scripts.gwp);
    /**
     * TODO: Currently only supports one gwp
     * Can update to support more
     */
    const icon = document.querySelector('.cart__free-shipping-progress__gift-icon');
    const indicator = document.querySelector('.cart__free-shipping-indicator');
    const maxValue = parseInt(indicator.getAttribute('aria-valuemax')) * 100;
    const threshold = gwpConfig.products[0].threshold;
    const percentage = (threshold / maxValue) * 100;
    icon.style.display = 'block';
    icon.style.left = `${percentage > 100 ? 100 : percentage}%`;

    let sections = await fetch("/?sections=cart-items,cart-json,cart").then((response) => response.json());
    let cart = await fetch(window.Shopify.routes.root + 'cart.js').then((response) => response.json());
    let data = await checkGWP({ ...cart, sections: sections });
    updateCart(data);
  }
}

const initCart = async () => {
    await renderCartOnLoad();

    if (document.body.classList.contains('template-cart')) {
        updateCartGWPs();
        if (calpak.isset(localStorage.getItem('guest_checkout')) && localStorage.getItem('guest_checkout')) {
            document.querySelector('.cart-sidebar .button--checkout').setAttribute('href', '/checkout');
        }
    }

    // setTimeout(() => {
        [...document.querySelectorAll('svg')]
            .filter(svg => svg.getAttribute('role') !== 'img')
            .forEach(svg => svg.setAttribute('aria-hidden', 'true'));
        [...document.querySelectorAll('.dynamic-checkout__content div[role="button"], .dynamic-checkout__content iframe')]
            .forEach(btn => {
                btn.setAttribute('role', 'link');
                btn.setAttribute('tabindex', '0');
            });
    // }, 10);

    document.dispatchEvent(new Event("calpak:cart-loaded"))
    // console.log('calpak:cart-loaded');
}

document.addEventListener("calpak:ready", () => {
    initCart()
});

const addMultiItemsToCart = function(variantItems, callback, always, final_sale = false, true_final_sale = false, preorder = false, email = false, message = false, sendOn = false, firstName = false, lastName = false, productForm, properties = {}) {
    if(typeof final_sale == 'undefined') final_sale = false;
    if(typeof true_final_sale == 'undefined') true_final_sale = false;
    if(typeof preorder == 'undefined') preorder = false;
    if(typeof variantItems != 'object' || variantItems.length == 0) return;

    let items = variantItems.map(variantItem => {
        return {
            id: variantItem.variantId,
            quantity: variantItem.quantity,
            properties
        }
    })

    if(final_sale) {
        items[0].properties['_final-sale'] = true;
        items[0].properties['_LPROP'] = "Final Sale";
    }
    if(true_final_sale) {
        items[0].properties['_true-final-sale'] = true;
        items[0].properties['_LPROP'] = "Final Sale";
    }
    if(preorder) items[0].properties['_preorder'] = preorder;

    const recipientCheckbox = document.getElementById('recipient-checkbox');
    
    if (recipientCheckbox && recipientCheckbox.checked && productForm.querySelector('input[name="recipient-email"]')){                        
        if (firstName && lastName) items[0].properties['Recipient name'] = `${firstName} ${lastName}`;
        if (firstName && !lastName) items[0].properties['Recipient name'] = firstName;
        if (email) items[0].properties['Recipient email'] = email;
        if (message) items[0].properties['Message'] = message;
        if (sendOn) items[0].properties['Send on'] = sendOn;
        items[0].properties['__shopify_send_gift_card_to_recipient'] = true;
    }

    let formData = {
        cb: Date.now(),
        items: items,
        sections: 'cart-items,cart-json,cart-pair-upsell,cart'
    };

    if(typeof always != 'function') always = () => {};

    fetch(`${routes.cart_add_url}.js`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    })
    .then(response => {
        if(!response.ok) {
            if(response.status == 422) {
                alert("Product not avalable!");
            } else {
                alert("Error adding product!");
            }

            throw new Error(`HTTP error! status: ${response.status}`);
        }

        return response.json();
    })
    .then(async response => {
        trackAddToCart(response)
        document.dispatchEvent(new CustomEvent('theme:cart:updated', { detail: { cart: response } }));
        if(typeof callback == 'function') callback(response);
    })
    .catch((error) => {
        console.error('Error:', error);
    })
    .then(always, always);
}
calpak.addMultiItemsToCart = addMultiItemsToCart


const initCartUpsellProducts = (cart) =>{
    document.querySelectorAll(".cart__upsell .product-unit").forEach(product => {
        const productId = product.getAttribute("data-id");
        let isInCart = false;
        cart.items.forEach(item => {
            if (item.product_id == productId) {
                isInCart = true;
            }
        });
        if(isInCart)
            product.classList.add("hidden");
        else
            product.classList.remove("hidden");
    })
}

document.addEventListener("theme:cart:updated", (e) => {
    const cart = JSON.parse(calpak.stripHTML(e.detail.cart.sections["cart-json"]));
    initCartUpsellProducts(cart)
});

document.addEventListener('calpak:cart-loaded', async (e) => {
    const cart = await calpak.cart.getState();
    initCartUpsellProducts(cart)
    // if(document.querySelector(".loop-return-coverage__title"))
    // document.querySelector(".loop-return-coverage__title").innerHTML = "Return Coverage";
    // if(document.querySelector(".loop-return-coverage__cta__standard"))
    // document.querySelector(".loop-return-coverage__cta__standard").innerHTML = "Continue without Return Coverage";
})
window.addEventListener('gorgias-bridge-loaded', function () {
  window.GorgiasBridge.subscribeToCartUpdated(function() {
    initCart();
    openCart();
  })
})